import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Fa from 'react-fontawesome';
import { reduce, find, groupBy, map } from 'lodash';
import { Tooltip, OverlayTrigger } from 'react-bootstrap';
import NumberDisplay from '../../../../components/number-display';
import { getTruVoiceClientsLoading, getTruVoiceClientsLoaded, getTruVoiceClients } from '../../AdminReducer';
import styles from './styles.css';

class TruVoiceRenderer extends Component {
  constructor(props) {
    super(props);
    this.state = {};
    this.handleClientClick = this.handleClientClick.bind(this);
  }

  handleClientClick(e) {
    const {
      disabled,
    } = this.props;
    e.preventDefault();
    if (!disabled) {
      this.props.requestEditOrganiztion(this.props.data);
    }
  }

  renderProgram(program) {
    const { data } = this.props;
    const { type, total } = program;
    let l = type;
    if (type === 'Win Loss') {
      l = 'wl';
    } else if (type === 'Customer Experience') {
      l = 'ce';
    } else if (type === 'Voice of the Buyer') {
      l = 'vb';
    } else if (type === 'Market Research') {
      l = 'mr';
    }
    const tip = (
      <Tooltip id={`${data._id}|${type}`}>
        <div><NumberDisplay suffix={`${type} program`} suffixIsUnit precision={0} value={total} /></div>
      </Tooltip>
    );
    return (
      <span key={type} className={`${styles.type} ${styles[l]}`}>
        <OverlayTrigger trigger={['hover', 'focus']} placement="top" overlay={tip}>
          <span>{l}</span>
        </OverlayTrigger>
      </span>
    );
  }


  render() {
    const {
      data, disabled,
      loading, loaded, truVoiceClients,
    } = this.props;
    const organization = data;
    if (!organization) {
      return null;
    }
    if (loading) {
      return (<Fa name="spinner" spin className="text-muted" />);
    }
    if (!loaded) {
      return null;
    }
    const clients = reduce(organization.tru_voice_clients, (results, client) => {
      const clientId = client.client_id;
      if (truVoiceClients[clientId]) {
        const tvClient = truVoiceClients[clientId];
        const c = { name: tvClient.name };
        const allPrograms = reduce(client.program_ids, (programs, programId) => {
          const prog = find(tvClient.programs, { program_id: programId });
          if (prog) {
            programs.push(prog);
          }
          return programs;
        }, []);
        const allGroups = groupBy(allPrograms, 'type_name');
        c.programs = reduce(allGroups, (groups, programs, type) => {
          groups.push({
            total: programs.length,
            type,
          });
          return groups;
        }, []);
        results.push(c);
      }
      return results;
    }, []);
    if (clients.length === 1) {
      return (
        <div>
          <nobr>
            <a
              className={disabled ? 'btn btn-xs btn-disabled' : 'btn btn-xs btn-default'}
              href=""
              onClick={this.handleClientClick}
            >
              <span>{clients[0].name}</span>
              {': '}
              {clients[0].programs.map(prog => this.renderProgram(prog))}
            </a>
          </nobr>
        </div>
      );
    }

    return (
      <a
        className={disabled ? 'text-muted' : null}
        href=""
        onClick={this.handleClientClick}
      >
        {clients.length === 0 && <span>Assign Programs</span>}
        {clients.length !== 0 && <span>{map(clients, 'name').join(', ')}</span>}
      </a>
    );
  }
}

TruVoiceRenderer.propTypes = {
  value: PropTypes.string,
  data: PropTypes.shape({
    _id: PropTypes.string.isRequired,
    display_name: PropTypes.string,
    name: PropTypes.string,
    is_demo: PropTypes.bool,
    tru_voice_clients: PropTypes.arrayOf(PropTypes.shape({})),
  }),
  loading: PropTypes.bool,
  loaded: PropTypes.bool,
  truVoiceClients: PropTypes.shape({}),
  disabled: PropTypes.bool,
  requestEditOrganiztion: PropTypes.func,
};
TruVoiceRenderer.defaultProps = {
  value: null,
  data: null,
  disabled: false,
  truVoiceClients: {},
  loaded: false,
  loading: false,
  requestEditOrganiztion: () => {},
};

function mapStateToProps(state) {
  return {
    truVoiceClients: getTruVoiceClients(state),
    loading: getTruVoiceClientsLoading(state),
    loaded: getTruVoiceClientsLoaded(state),
  };
}

export default connect(mapStateToProps, null, null, { forwardRef: true })(TruVoiceRenderer);
